module.exports = __webpack_public_path__ + "img/swat-team-06.48693e2.png";